import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

api.defaults.headers['Content-Type'] = 'application/json';
api.defaults.headers['Access-Control-Allow-Origin'] = '*';
api.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('auth')}`;

export default api;
